import { css } from '@linaria/core';
import { FC } from 'react';
import { breakpoints } from 'styles/utils';
export const InfoMessage: FC = () => {
  return <div className={infoMessageContainer}>
      <span className={infoMessageTitle}>Predictable costs in your cloud region -&nbsp;</span>
      <span className={infoMessageDescription}>deploy your model on dedicated compute.</span>
    </div>;
};
const infoMessageContainer = "odules__Playground__Components__HeaderMessages__InfoMessage_tsx-infoMessageContainer-i1y0pmiz";
const infoMessageTitle = "odules__Playground__Components__HeaderMessages__InfoMessage_tsx-infoMessageTitle-i1cykl82";
const infoMessageDescription = "odules__Playground__Components__HeaderMessages__InfoMessage_tsx-infoMessageDescription-i143ruvx";

require("./InfoMessage.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./InfoMessage.tsx");